export class NumRange {
    from: number;
    to: number;

    public constructor(from: number, to: number) {
        this.from = from;
        this.to = to;
    }

    public static fromRaw(rawData: any): NumRange {
        return new NumRange(
            rawData.from,
            rawData.to ? rawData.to : rawData.from,
        )
    }

    public static ONE(): NumRange {
        return new NumRange(1, 1);
    }

    public equals(other: NumRange): boolean {
        return this.from === other.from && this.to === other.to;
    }
}